import { render, staticRenderFns } from "./check-info.vue?vue&type=template&id=8310aa12&scoped=true"
import script from "./check-info.vue?vue&type=script&lang=js"
export * from "./check-info.vue?vue&type=script&lang=js"
import style0 from "./check-info.vue?vue&type=style&index=0&id=8310aa12&prod&scoped=true&lang=css"
import style1 from "./check-info.vue?vue&type=style&index=1&id=8310aa12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8310aa12",
  null
  
)

export default component.exports